import React from 'react';
import { Helmet } from 'react-helmet';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import ScheduledJobScheduler from './components/Operations/Jobs/ScheduledJobScheduler';
import AvailableVariables from './components/Operations/AvailableVariables';
import BlackList from './components/Operations/BlackList';
import UnblockSuperAdmin from './components/Operations/UnblockSuperAdmin/UnblockSuperAdmin';
import InboxOps from './components/Operations/inboxOps';
import PushOps from './components/Operations/pushOps';
import SMSOps from './components/Operations/smsOps';
import UsersKYC from './components/Operations/UsersKYC';
import WaitingUsers from './components/Operations/WaitingUsers';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import ConsoleLogs from './components/AccessLogs/ConsoleLogs';
import UserLogs from './components/AccessLogs/UserLogs';
import LoginLogs from './components/AccessLogs/LoginLogs';
import UserSessionLogout from './components/AccessLogs/UserSessionLogout';
import DicountCouponComponentEdit from './components/DiscountCoupons/Edit';
import DicountCouponComponent from './components/DiscountCoupons/Index';
import CouponUserList from './components/DiscountCoupons/UserList';
import DicountCouponListComponent from './components/DiscountCoupons/List';
import TransactionComponent from './components/DoosraCash/TransactionComponent';
import FinancialInsightComponent from './components/Financials/Insights';
import FinancialPlansComponent from './components/Financials/Plan';
import FinancialRevenueComponent from './components/Financials/Revenue';
import Refund from './components/Financials/Refund';
import KeywordFilter from './components/KeywordFilter';
import Login from './components/Login/Login';
import Otp from './components/Login/Otp';
import ResetPassword from './components/Login/ResetPassword';
import BlockSender from './components/Operations/BlockSender';
import TrustedServices from './components/Operations/TrustedServices/TrustedServices';
import VMNManagement from './components/Operations/VMNManagement/VMNManagement';
import VMNSOverview from './components/Operations/VMNSOverview/VMNSOverview';
import MessageLogs from './components/Operations/MessageLogs/MessageLogs';
import CallLogs from './components/Operations/CallLogs/CallLogs';
import LogDetails from './components/Others/LogDetails';
import PrivateRoute from './components/Others/PrivateRoute';
import TwoFASendOtp from './components/Others/TwoFASendOtp';
import Dashboard from './components/pageLevel/Dashboard';
import Navbar from './components/pageLevel/NavBar';
import Reports from './components/Reports';
import RetailStore from './components/Retail/RetailPortal';
import RetailStoreCoupounsList from './components/Retail/RetailPortalCouponsList';
import RetailStoreList from './components/Retail/RetailPortalList';
import Rewards from './components/Rewards';
// import CentralVmnList from './components/Operations/CentralVmn/CentralVmnList';
import OneTimeJobs from './components/Operations/Jobs/OneTimeJobScheduler';
import store from './store';
// eslint-disable-next-line camelcase
import { setup_axios_interceptor } from './utils/HttpRequests';

// toast.configure({ time: 30000 });

setup_axios_interceptor(store);
function App() {
  return (
    <Provider store={store}>
      <ToastContainer />
      <Router>
        <Helmet>
          <title>Admin - Doosra</title>
        </Helmet>
        <Navbar />
        <Switch>
          <Route exact path="/" component={Login} />
          <Route exact path="/verify-otp" component={Otp} />
          <Route exact path="/reset-password" component={ResetPassword} />
          <PrivateRoute exact path="/dashboard" component={Dashboard} />
          {/* <PrivateRoute exact path="/flights" component={Flights} /> */}
          {/* <PrivateRoute exact path="/create-flight" component={CreateFlight} /> */}
          <PrivateRoute exact path="/logs/users" component={UserLogs} />
          <PrivateRoute exact path="/logs/login-history" component={LoginLogs} />
          <PrivateRoute exact path="/logs/user-session-logout" component={UserSessionLogout} />

          <PrivateRoute exact path="/logs/console" component={ConsoleLogs} />
          <PrivateRoute exact path="/users-logs/:id" component={LogDetails} />
          {/* <PrivateRoute
            exact
            path="/flight-details/:id"
            component={FlightDetails}
          /> */}
          <PrivateRoute
            exact
            path="/transactions"
            component={TransactionComponent}
          />
          <PrivateRoute
            exact
            path="/discount-coupon"
            component={DicountCouponListComponent}
          />
          <PrivateRoute
            exact
            path="/discount-coupon/new"
            component={DicountCouponComponent}
          />
          <PrivateRoute
            exact
            path="/discount-coupon/users/:id"
            component={CouponUserList}
          />
          <PrivateRoute
            exact
            path="/discount-coupon/:id"
            component={DicountCouponComponentEdit}
          />
          <PrivateRoute exact path="/retail" component={RetailStoreList} />
          <PrivateRoute exact path="/retail/new" component={RetailStore} />
          <PrivateRoute
            exact
            path="/retail/:id"
            component={RetailStoreCoupounsList}
          />
          <PrivateRoute
            exact
            path="/keyword-filter"
            component={KeywordFilter}
          />
          <PrivateRoute
            exact
            path="/financials/plans"
            component={FinancialPlansComponent}
          />
          <PrivateRoute
            exact
            path="/financials/revenue"
            component={FinancialRevenueComponent}
          />
          <PrivateRoute
            exact
            path="/financials/insights"
            component={FinancialInsightComponent}
          />
          <PrivateRoute
            exact
            path="/financials/refund"
            component={Refund}
          />
          <Route exact path="/2fa-send-otp" component={TwoFASendOtp} />
          <PrivateRoute
            exact
            path="/retail/:id"
            component={RetailStoreCoupounsList}
          />
          <PrivateRoute
            exact
            path="/keyword-filter"
            component={KeywordFilter}
          />
          <PrivateRoute
            exact
            path="/financials/plans"
            component={FinancialPlansComponent}
          />
          <PrivateRoute
            exact
            path="/financials/revenue"
            component={FinancialRevenueComponent}
          />
          <PrivateRoute
            exact
            path="/financials/insights"
            component={FinancialInsightComponent}
          />
          <PrivateRoute
            exact
            path="/financials/refund"
            component={Refund}
          />
          <PrivateRoute
            exact
            path="/operations/block"
            component={BlockSender}
          />
          <PrivateRoute
            exact
            path="/operations/allot-vmn"
            component={VMNManagement}
          />
          <PrivateRoute
            exact
            path="/operations/trusted-services"
            component={TrustedServices}
          />
          <PrivateRoute
            exact
            path="/operations/vmns"
            component={VMNSOverview}
          />
          {/* <PrivateRoute
            exact
            path="/operations/central-vmns"
            component={CentralVmnList}
          /> */}
          {/* <PrivateRoute
            exact
            path="/operations/alohaa-vmns"
            component={AlohaaVmns}
          /> */}
          <PrivateRoute
            exact
            path="/operations/message-logs"
            component={MessageLogs}
          />
          <PrivateRoute
            exact
            path="/operations/call-logs"
            component={CallLogs}
          />
          <PrivateRoute
            exact
            path="/operations/onetime-jobs"
            component={OneTimeJobs}
          />
          <PrivateRoute
            exact
            path="/operations/scheduled-jobs"
            component={ScheduledJobScheduler}
          />
          <PrivateRoute exact path="/reports" component={Reports} />
          <PrivateRoute exact path="/rewards" component={Rewards} />
          <PrivateRoute exact path="/rewards/create" component={Rewards} />
          <PrivateRoute exact path="/operations/sms" component={SMSOps} />
          <PrivateRoute exact path="/operations/push" component={PushOps} />
          <PrivateRoute exact path="/operations/inbox" component={InboxOps} />
          <PrivateRoute
            exact
            path="/operations/variables"
            component={AvailableVariables}
          />
          <PrivateRoute
            exact
            path="/operations/users-kyc"
            component={UsersKYC}
          />
          <PrivateRoute
            exact
            path="/operations/waiting-users"
            component={WaitingUsers}
          />
          <PrivateRoute
            exact
            path="/operations/black-list"
            component={BlackList}
          />
          <PrivateRoute
            exact
            path="/operations/unblock-super-admin"
            component={UnblockSuperAdmin}
          />
        </Switch>
      </Router>
    </Provider>
  );
}

export default App;
